import React from "react"
import { TRANSACTIONAL } from "constants/paths"
import { Redirect } from "react-router-dom"

const Home = () => <Redirect to={TRANSACTIONAL} />

export default Home
